<template>
	<v-app class="app-container">
		<nav-menu v-if="!isDeployInProgress && isAuthenticated"></nav-menu>
		<v-main>
			<DeployInProgress v-if="isDeployInProgress" />
			<router-view v-else />
		</v-main>
		<GeneralDialog />
		<LoadingOverlay />
	</v-app>
</template>

<script lang="ts">
import Vue from "vue";
import DeployInProgress from "./views/deploy-in-progress/DeployInProgress.vue";
import NavMenu from "./components/NavMenu.vue";
import GeneralDialog from "@/components/GeneralDialog.vue";
import LoadingOverlay from "@/components/loading/LoadingOverlay.vue";
import ConfigurationService from "./services/configuration/configuration.service";

export default Vue.extend({
	name: "App",
	components: {
		DeployInProgress,
		NavMenu,
		GeneralDialog,
		LoadingOverlay
	},
	mounted() {
		document.body.classList.remove("bootstrap-loading");
		this.$store.commit("desactivateDialog");
	},
	computed: {
		isAuthenticated(): boolean {
			return this.$store.state.user.logged;
		},
		isDeployInProgress(): boolean {
			return ConfigurationService.value.deployInProgress;
		}
	}
});
</script>
<style scoped>
.app-container {
	overflow: hidden;
}
</style>
